import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Store as StoreModel } from '@core/models';
import { environment } from '@environments/environment';
import { switchMap, take, catchError, filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { selectStore } from '@store/selectors';
import { Category } from '@core/models';
import { IResponseSuccess } from '@core/interfaces';

@Injectable({
	providedIn: 'root',
})
export class CategoryService {
	store$: Observable<StoreModel | null>;

	constructor(
		private http: HttpClient,
		private store: Store<AppState>
	) {
		this.store$ = this.store.select(selectStore);
	}

	getCategoryByLocalChannelId(localChannelId: string): Observable<IResponseSuccess<Category>> {
		return this.store$.pipe(
			filter(store => !!store),
			switchMap(store => {
				return this.http.get<IResponseSuccess<Category>>(`${environment.microConfiguraciones}/categorias`, {
					headers: {
						authorization: store.apiKey,
					},
					params: {
						localId: store.idLocal,
						localCanalId: localChannelId,
					},
				});
			}),
			catchError(error => {
				return throwError(() => error);
			}),
			take(1)
		);
	}
}
